<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-1" x="0" y="0" width="90.07" height="90.07"/>
  <g>
    <rect class="cls-3" x="8.66" y="33.31" width="22.23" height="31.43" rx="4.45" ry="4.45"/>
    <rect class="cls-3" x="34.1" y="22.66" width="22.23" height="42.08" rx="4.45" ry="4.45"/>
    <rect class="cls-3" x="59.55" y="11.93" width="22.23" height="52.81" rx="4.45" ry="4.45"/>
    <g>
      <path class="cls-2" d="M74.51,74.64H9.8c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5H74.51c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5Z"/>
      <path class="cls-2" d="M74.51,77.99l6.69-3.86c.76-.44,.76-1.53,0-1.97l-6.69-3.86c-.76-.44-1.71,.11-1.71,.99v7.73c0,.88,.95,1.42,1.71,.99Z"/>
    </g>
    <path class="cls-1" d="M46.86,31.68l-.02,2.83c1.11,.11,2.16,.33,3.15,.67,.98,.33,1.83,.75,2.53,1.25l-1.34,3.67c-.75-.54-1.64-.97-2.67-1.28-1.03-.32-2.07-.48-3.14-.49-1.06,0-1.81,.13-2.24,.42-.43,.29-.65,.65-.65,1.08,0,.36,.14,.67,.43,.92,.29,.25,.82,.46,1.59,.64l2.91,.64c3.15,.72,4.72,2.45,4.7,5.16-.01,1.44-.5,2.66-1.48,3.66-.98,1-2.28,1.65-3.92,1.94l-.02,2.96-3.58-.03,.02-2.88c-.89-.11-1.75-.33-2.56-.66-.81-.33-1.48-.74-2.01-1.23l1.29-3.44c.61,.48,1.34,.86,2.18,1.13,.84,.27,1.74,.41,2.7,.42,.89,0,1.59-.15,2.09-.48,.5-.32,.75-.74,.75-1.26,0-.34-.14-.63-.43-.87-.29-.23-.8-.44-1.54-.61l-2.91-.67c-3.2-.73-4.8-2.41-4.78-5.05,.01-1.46,.51-2.67,1.49-3.65s2.27-1.6,3.85-1.88l.02-2.96,3.58,.03Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "VolumeDollarsTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #59c5c7;
  }
</style>